interface FileAnalysisStatus {
    completed?: boolean;
}

export interface AnalyzableLineItem {
    product?: {
        has_file_2d?: boolean;
        has_file_3d?: boolean;
        analysis_status?: {
            file_2d?: FileAnalysisStatus | null;
            file_3d?: FileAnalysisStatus | null;
        } | null;
    } | null;
}

/**
 * A part is analyzing while an uploaded file's analysis (including the Fastlane
 * drawing analysis) has not finished. Prices returned before then are
 * provisional: the default lead time is re-selected once analysis completes.
 */
export const isLineItemAnalyzing = (item?: AnalyzableLineItem | null): boolean => {
    const product = item?.product;
    const analysis = product?.analysis_status;
    if (!product || !analysis) return false;

    return (
        (product.has_file_3d === true && analysis.file_3d?.completed === false) ||
        (product.has_file_2d === true && analysis.file_2d?.completed === false)
    );
};

export const isAnyLineItemAnalyzing = (items?: ReadonlyArray<AnalyzableLineItem | null> | null): boolean =>
    (items ?? []).some(isLineItemAnalyzing);
